import { WarningHexagonalIcon } from "@images/svgIcons/warningIcon"
import { Text } from "@/components/ui/baseUi/text"

export const HUBanner = ({ type, text }: { type: "warning" | "success" | "info"; text: string }) => {
  return (
    <div className="flex flex-row items-center gap-3 rounded-xl bg-primary-100/50 p-3">
      <div className="flex">
        {type === "warning" && <WarningHexagonalIcon color="var(--primary-600)" width={18} height={18} />}
      </div>
      <Text fontStyle="BM">{text}</Text>
    </div>
  )
}
